import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import {
  HeatingConfigurationRegulationProperties,
  CallForHeatDemandProperties,
  FeatureDeprecated,
  FeatureNames,
  RenameHeatingCircuitCommands,
  RenameHeatingCircuitProperties,
  IsActiveProperty,
  IsStringValueProperty,
  Feature,
  FeaturePropertyKey,
  DcSensorValueProperties,
} from '@vi-iot/client';

import { InstallationFeaturesStore } from '@store';

import { FeaturesDetailsOverlayTypeEnum } from '../../installation-overlay.model';
import { PillType } from '../../../../shared/components/pill/pill.model';

@Component({
  selector: 'app-call-for-heat-heating-zone-features-panel',
  templateUrl: './call-for-heat-heating-zone-features-panel.component.html',
  styleUrls: ['./call-for-heat-heating-zone-features-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CallForHeatHeatingZoneFeaturesPanelComponent implements OnInit {
  readonly pillType = PillType;
  readonly featurePropertyKey = FeaturePropertyKey;
  availableOverlays = FeaturesDetailsOverlayTypeEnum;

  @Input() deviceSelectId: string;
  @Input() deviceId: string;
  @Input() header: string;

  heatingDemand$: Observable<Feature<CallForHeatDemandProperties, never>>;
  heatingCurvePresets$: Observable<Feature<IsStringValueProperty, never>>;
  heatingConfigurationRegulation$: Observable<
    Feature<HeatingConfigurationRegulationProperties, never>
  >;
  heatingSensorsTemperature$: Observable<Feature<DcSensorValueProperties, never>>;
  heatingPump$: Observable<Feature<IsActiveProperty, never>>;

  heatingZoneNameFeature$: Observable<
    FeatureDeprecated<RenameHeatingCircuitProperties, RenameHeatingCircuitCommands>
  >;

  constructor(public installationFeaturesStore: InstallationFeaturesStore) {}

  ngOnInit(): void {
    this.heatingDemand$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.callForHeatDemand,
      this.deviceId
    );
    this.heatingCurvePresets$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.callForHeatHeatingCurvePresets,
      this.deviceId
    );
    this.heatingConfigurationRegulation$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.callForHeatConfigurationRegulation,
      this.deviceId
    );
    this.heatingSensorsTemperature$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.callForHeatSensorsTemperature,
      this.deviceId
    );
    this.heatingPump$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.callForHeatPump,
      this.deviceId
    );
  }
}
